import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const DeleteIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M8 4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4C16 4.55228 15.5523 5 15 5H9C8.44772 5 8 4.55228 8 4ZM3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H19V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V8H4C3.44772 8 3 7.55228 3 7ZM7 8V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V8H7ZM10 10C10.5523 10 11 10.4477 11 11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11C9 10.4477 9.44772 10 10 10ZM14 10C14.5523 10 15 10.4477 15 11V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V11C13 10.4477 13.4477 10 14 10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

DeleteIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(DeleteIcon);
